import {
	DeploymentIcon,
	SearchIcon,
	PrototypeIcon,
	BulbIcon as ConceptIcon,
} from '@components/icons';
import ResearchImage from '@static/images/figures/research.webp';
import ConceptImage from '@static/images/figures/concept.webp';
import PrototypingImage from '@static/images/figures/prototyping.webp';
import ProductImage from '@static/images/figures/final-product.webp';
import adobeXdIcon from '@images/icons/adobe-xd-icon.svg';
import figmaIcon from '@images/icons/figma-icon.svg';

export const howWeWorkData = [
	{
		Icon: SearchIcon,
		title: 'Research',
		description: `The base of this stage is a talk with the client. What is the project's theme, what should be exposed, what is the primary goal of this project? And the most important - what will be the effect.`,
		image: ResearchImage,
	},
	{
		Icon: ConceptIcon,
		title: 'Concept',
		description: `We build the documentation. First, we are going to define the problem. We could do this by answering questions like the company's goal or who will use it?`,
		image: ConceptImage,
	},
	{
		Icon: PrototypeIcon,
		title: 'Digital prototyping',
		description: `An early sample of our work. It could save our time, this is the stage we can for the first time see a future product and at the same time put some changes.`,
		image: PrototypingImage,
	},
	{
		Icon: DeploymentIcon,
		title: 'Final Product',
		description: `The closing stage of design services. You get UI design files and all the documentation connected with user experience.`,
		image: ProductImage,
	},
];

export const weWorkWithData = [
	{
		icon: adobeXdIcon,
		name: 'Adobe Xd',
	},
	{
		icon: figmaIcon,
		name: 'Figma',
	},
];
